import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QrCode, Storefront, Gift, TrendUp, ArrowRight } from "@phosphor-icons/react";
import api from "@/lib/api";
import { pts, timeAgo, initials } from "@/lib/format";
import OneKiteQR from "@/components/OneKiteQR";

export default function CustomerHome() {
  const nav = useNavigate();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/customer/home").then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d) return <div className="pt-10 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-6 pt-2">
      <div className="flex items-center gap-3 fade-up">
        <div className="h-12 w-12 rounded-full bg-primary/15 flex items-center justify-center overflow-hidden">
          {d.photo ? <img src={d.photo} alt="" className="h-full w-full object-cover" /> : <span className="font-display font-bold text-primary">{initials(d.name)}</span>}
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Welcome back</p>
          <h1 className="font-display font-bold text-xl leading-tight" data-testid="customer-name">{d.name}</h1>
        </div>
      </div>

      <button data-testid="home-qr-card" onClick={() => nav("/app/identity")} className="w-full text-left card-surface p-5 relative overflow-hidden fade-up" style={{ animationDelay: "60ms" }}>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-primary font-mono text-xs tracking-widest uppercase mb-1">OneKite ID</p>
            <p className="font-display font-bold text-lg tabular-nums" data-testid="home-onekite-id">{d.onekite_id_formatted || d.onekite_id}</p>
            {d.onekite_name && <p className="text-sm text-muted-foreground">@{d.onekite_name}</p>}
            <p className="text-xs text-muted-foreground mt-3 flex items-center gap-1">Manage identity <ArrowRight size={12} /></p>
          </div>
          <div className="scale-[0.55] origin-right -my-6">
            <OneKiteQR value={d.qr_token} size={140} />
          </div>
        </div>
      </button>

      <div className="grid grid-cols-2 gap-3 fade-up" style={{ animationDelay: "120ms" }}>
        <div className="card-surface p-4">
          <Storefront size={22} weight="duotone" className="text-primary mb-2" />
          <p className="font-display font-bold text-2xl" data-testid="home-businesses-count">{d.businesses_joined}</p>
          <p className="text-xs text-muted-foreground">Businesses joined</p>
        </div>
        <div className="card-surface p-4">
          <Gift size={22} weight="duotone" className="text-primary mb-2" />
          <p className="font-display font-bold text-2xl" data-testid="home-rewards-count">{d.available_rewards}</p>
          <p className="text-xs text-muted-foreground">Rewards available</p>
        </div>
      </div>

      <div className="fade-up" style={{ animationDelay: "180ms" }}>
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-display font-semibold text-base">Recent activity</h2>
          <TrendUp size={18} className="text-muted-foreground" />
        </div>
        <div className="space-y-2">
          {d.recent_activity.length === 0 && <p className="text-sm text-muted-foreground">No activity yet. Visit a business to start earning.</p>}
          {d.recent_activity.map((a) => (
            <div key={a.id} className="card-surface p-3.5 flex items-center justify-between" data-testid="activity-item">
              <div>
                <p className="text-sm font-medium">{a.business}</p>
                <p className="text-xs text-muted-foreground capitalize">{a.type} · {timeAgo(a.created_at)}</p>
              </div>
              <span className={`font-display font-bold ${a.points >= 0 ? "text-primary" : "text-destructive"}`}>
                {a.points >= 0 ? "+" : ""}{pts(a.points)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
